import {
  queryClient,
  searchItemsAutocompleteOptions,
  searchItemsInfiniteOptions
} from '@metto/http-clients/api';
import type {
  AnyContext,
  AnyRoute,
  LoaderFnContext
} from '@tanstack/react-router';
import { EmptySearchQuery } from '../types';

type FetchSearchItems = <T extends AnyRoute>(
  ctx: LoaderFnContext<unknown, T, any, any, any, AnyContext>
) => any;

export const fetchSearchItems: FetchSearchItems = async ({ deps }) => {
  // Only load when q is empty (on first mount), not when q is
  // updated in the course of regular user searching.
  if (deps.search?.q) return;

  const p1 = queryClient.prefetchQuery({
    ...searchItemsAutocompleteOptions({
      query: EmptySearchQuery
    })
  });

  const p2 = queryClient.prefetchInfiniteQuery({
    ...searchItemsInfiniteOptions({
      query: EmptySearchQuery
    }),
    initialPageParam: 1
  });

  await Promise.all([p1, p2]);
};
